import React from 'react';
import Row from 'src/components/Row';
import Col from 'src/components/Col';
import Input from 'src/components/Input';
import ReactSelect from 'react-select';
import { selectStyles } from './selectStyles';

interface BuildingLevelOption {
  value: string;
  label: string;
}

interface PropertyDetailsSectionProps {
  suiteFormData: any;
  isSparkDisabled: boolean;
  buildingOptions: BuildingLevelOption[];
  levelOptions: BuildingLevelOption[];
  selectedBuilding: BuildingLevelOption | null;
  selectedLevel: BuildingLevelOption | null;
  onSetSuiteFormData: (data: any) => void;
  onChangeBuilding: (option: any) => void;
  onChangeLevel: (option: any) => void;
}

const PropertyDetailsSection = ({
  suiteFormData,
  isSparkDisabled,
  buildingOptions,
  levelOptions,
  selectedBuilding,
  selectedLevel,
  onSetSuiteFormData,
  onChangeBuilding,
  onChangeLevel,
}: PropertyDetailsSectionProps) => {
  return (
    <>
      <h2>Property Details</h2>
      <Row>
        <Col xs="12" md="6">
          <div className="suite-form-field">
            <Input
              value={suiteFormData.stratalot ? suiteFormData.stratalot : ''}
              onChange={(e: any) =>
                onSetSuiteFormData({ stratalot: e.target.value })
              }
              label="Strata Lot :"
              placeholder="Strata Lot"
              block
              disabled={isSparkDisabled}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs="12" md="6">
          <div className="suite-form-field">
            <div className="reporting__heading suite-form-label">Building :</div>
            <ReactSelect
              value={selectedBuilding}
              onChange={onChangeBuilding}
              options={buildingOptions}
              placeholder="Select a Building"
              isClearable
              isDisabled={isSparkDisabled}
              styles={selectStyles}
            />
          </div>
        </Col>
        <Col xs="12" md="6">
          <div className="suite-form-field">
            <div className="reporting__heading suite-form-label">Level :</div>
            <ReactSelect
              value={selectedLevel}
              onChange={onChangeLevel}
              options={levelOptions}
              placeholder={
                selectedBuilding
                  ? 'Select a Level'
                  : 'Select a building first'
              }
              isClearable
              isDisabled={isSparkDisabled || !selectedBuilding}
              styles={selectStyles}
            />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default PropertyDetailsSection;
